import { Box, Stack, Text } from '@chakra-ui/react';
import * as React from 'react';

import { FieldValidationError } from '../../../../client/legacy-shared-modules/csv/csv-field-mapping';
import { CsvFileDrop, ICsvFileDropProps } from './CsvFileDrop';
import {
  CsvImportAccountCreationConfiguration,
  ICsvImportAccountCreationConfigurationProps,
} from './CsvImportAccountCreationConfiguration';
import {
  CsvImportConfiguration,
  ICsvImportConfigurationProps,
} from './CsvImportConfiguration';
import { ValidationErrors } from './CsvValidationErrors';

export const CsvImportModalFrameImportContent: React.FC<
  {
    validationErrors: FieldValidationError | null;
    importConfig?: ICsvImportConfigurationProps;
    hasLoadingSideEffect?: boolean;
    onRemoveFile: (e: React.SyntheticEvent) => void;
    note?: string;
  } & ICsvFileDropProps
> = (props) => {
  return (
    <Stack spacing="6">
      {props.validationErrors && (
        <ValidationErrors validationErrors={props.validationErrors} />
      )}

      {!!props.importConfig && (
        <Box>
          <CsvImportConfiguration {...props.importConfig} />
        </Box>
      )}

      <Stack>
        <CsvFileDrop
          file={props.file}
          onFileChange={props.onFileChange}
          hasLoadingSideEffect={props.hasLoadingSideEffect}
          onRemoveFile={props.onRemoveFile}
        />

        {props.note && (
          <Text textStyle="compact" color="gray.600">
            {props.note}
          </Text>
        )}
      </Stack>
    </Stack>
  );
};
